import { styled, Stepper, StepConnector, stepConnectorClasses } from "@mui/material";

export const MyStepper = ({ children, ...options }) => {
    return (<Stepper
        sx={{
            width: "100%", mb: 2, '& .MuiStepLabel-label': { fontSize: '80%' },
        }}
        {...options}
        alternativeLabel
        connector={<CustomConnector />}
    >
        {children}
    </Stepper>);
}


const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.active}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main,
        },
    },
    [`&.${stepConnectorClasses.completed}`]: {
        [`& .${stepConnectorClasses.line}`]: {
            borderColor: theme.palette.primary.main,
        },
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: theme.palette.action.disabled,
        borderTopWidth: 3,
        borderRadius: 1
    },
}));
